module.exports = __webpack_public_path__ + "static/img/title.79cc748.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/DailyTask/img/top/title.png
// module id = 502
// module chunks = 0